import {Component, OnInit, AfterViewInit, ViewChild, OnDestroy} from '@angular/core';
import * as moment from 'moment';
import { PricePipe } from '@utils/pipes/price';
import { SpinnerService } from '@services/spinner-service';
import { FinancieraService } from '@services/financiera-service';
import { Observable } from 'rxjs/Observable';
import {PrecioMonitor} from '@common/precio-monitor';
import {compare} from '../precios';
import {CotizacionViewModel, PrecioGenericViewModel} from '@utils/ViewModels';
import {FormBuilder, FormGroup} from '@angular/forms';
import {FormSelectItem, FormSelectMultipleComponent, FormSelectMultipleItem} from '@common/form-components';
import {Subscription} from 'rxjs/Subscription';
import {SEARCH_TYPE_COLABORADOR, SearchService} from '@services/search-service';
import {PreciosService} from '@services/precios-service';
import {DialogsService} from '@services/dialogs-service';
import {Breakpoints, BreakpointsObserverService} from '@services/breakpoints-observer.service';
import {ResponsiveService} from '@services/responsive.service';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-financiera',
  templateUrl: './financiera.component.html',
  styleUrls: ['./financiera.component.scss', '../precios-common-styles.scss']
})
export class FinancieraComponent implements OnInit, AfterViewInit, OnDestroy {

  monitorKey = 'mon';
  grillaKey = 'gri';
  view = this.monitorKey;

  showFilters = false;

  cotizacion = [];

  entidadesOptions: FormSelectItem[] = [];
  subtiposOptions: FormSelectItem[] = [];
  responsablesOptions: FormSelectItem[] = [];
  validadoresOptions: FormSelectItem[] = [];

  monitorLoading = false;

  grillaLoaded = false;
  grillaLoading = false;
  cotizacionGrilla = [];

  columnas = ['Cotización', 'Publicación', 'Entidad', 'Subtipo', 'Precio', 'Responsable', 'Validador'];
  anchoDeCelda = ['14.285%', '14.285%', '14.285%', '14.285%', '14.285%', '14.285%', '14.29%'];

  filtersInitialState: DolarFilters = {
    ColumnOrder: 'Publicación',
    AscendingOrder: false,
    fechaCreacionDesde: moment().subtract(2, 'week').startOf('day').toDate(),
    fechaCreacionHasta: moment().endOf('day').toDate(),
    marcaTemporalDesde: null,
    marcaTemporalHasta: null,
    entidad: [],
    subentidad: [],
    page: 0,
    creador: [],
    validador: []
  };

  // añadimos un valor mas para buscar dado que se pueden validar coticaciones de mañana
  endOfDay = moment().add(1, 'days').endOf('day').toDate();

  private FECHA = {
    CREACION_DESDE: 'CD',
    CREACION_HASTA: 'CH',
    TEMPORAL_DESDE: 'TD',
    TEMPORAL_HASTA: 'TH'
  };

  scrollSubscriber;
  verticalScroll;

  private preciosMonitorRaw: CotizacionViewModel[] = [];
  monitorGenericoPrecios: PrecioMonitor[] = []

  grillaFilterForm: FormGroup;
  ordenMonitorForm: FormGroup;

  filterTipoPrecio = [
    {label: 'HOY', selected: true},
    {label: 'MAÑANA', selected: false},
  ];

  // hacemos un objeto pues las opciones son dinamicas
  ordeAgrRawOpts = {
    entidadFinanciera: {Label: 'Entidad Financiera', Id: 'ent'},
    subtipo: {Label: 'Subtipo', Id: 'sub'},
    publicacion: {Label: 'Hora de publicación', Id: 'publ'},
  };

  agruparMonitorOptions: FormSelectItem[] = [
    this.ordeAgrRawOpts.entidadFinanciera,
    this.ordeAgrRawOpts.subtipo,
  ];

  ordenarMonitorOptions: FormSelectItem[] = [
    this.ordeAgrRawOpts.subtipo,
    this.ordeAgrRawOpts.publicacion,
  ];

  subscriptionTsunami: Subscription[] = [];

  @ViewChild('responsableComponent') responsableComp: FormSelectMultipleComponent;
  @ViewChild('validadoresComponent') validadoresComp: FormSelectMultipleComponent;

  helpOverlayIsOpen = false;
  destroySubject = new Subject<void>();
  isMobile = false;
  constructor(
    private pricePipe: PricePipe,
    private spinnerService: SpinnerService,
    private financieraService: FinancieraService,
    private fb: FormBuilder,
    private searchService: SearchService,
    public preciosService: PreciosService,
    private dialogsService: DialogsService,
    private breakpointsService: BreakpointsObserverService,
    private responsiveService: ResponsiveService
  ) {
    breakpointsService.observe([Breakpoints.XSmall, Breakpoints.Small])
      .map(x => x.matches)
      .takeUntil(this.destroySubject)
      .subscribe(x => {
        this.isMobile = x;
      });

    this.grillaFilterForm = fb.group({
      ColumnOrder: this.filtersInitialState.ColumnOrder,
      AscendingOrder: this.filtersInitialState.AscendingOrder,
      fechaCreacionDesde: this.filtersInitialState.fechaCreacionDesde,
      fechaCreacionHasta: this.filtersInitialState.fechaCreacionHasta,
      marcaTemporalDesde: this.filtersInitialState.marcaTemporalDesde,
      marcaTemporalHasta: this.filtersInitialState.marcaTemporalHasta,
      entidad: [this.filtersInitialState.entidad],
      subentidad: [this.filtersInitialState.subentidad],
      page: this.filtersInitialState.page,
      creador: [this.filtersInitialState.creador],
      validador: [this.filtersInitialState.validador],
    });

    this.ordenMonitorForm = fb.group({
      monitorGroup: this.ordeAgrRawOpts.entidadFinanciera,
      monitorGroupDirection: true, // true = ascendente
      monitorOrder: this.ordeAgrRawOpts.subtipo,
      monitorOrderDirection: true, // true = ascendente
    });

    this.financieraService.loadOptions();
    this.financieraService.Options.subscribe(x => {
      if (x) {
        this.entidadesOptions = x.map(y => ({Id: y.ID, Label: y.Nombre, RawValue: JSON.stringify(y)}));
        this.loadSubtiposFilter();
      }
    });

    this.subscriptionTsunami.push(
      this.fechaCreacionDesdeCtrl.valueChanges.subscribe(x => {
        this.selectedDate(this.fechaCreacionDesdeCtrl.value, this.FECHA.CREACION_DESDE);
      }),

      this.fechaCreacionHastaCtrl.valueChanges.subscribe(x => {
        this.selectedDate(this.fechaCreacionHastaCtrl.value, this.FECHA.CREACION_HASTA);
      }),

      this.marcaTemporalDesdeCtrl.valueChanges.subscribe(x => {
        this.selectedDate(this.marcaTemporalDesdeCtrl.value, this.FECHA.TEMPORAL_DESDE);
      }),

      this.marcaTemporalHastaCtrl.valueChanges.subscribe(x => {
        this.selectedDate(this.marcaTemporalHastaCtrl.value, this.FECHA.TEMPORAL_HASTA);
      }),

      this.entidadesFilterCtrl.valueChanges.subscribe(x => {
        this.loadSubtiposFilter();
      }),

      this.monitorGroupCtrl.valueChanges.subscribe(x => {
        this.orderPreciosMonitor();
      }),

      this.monitorOrderCtrl.valueChanges.subscribe(x => {
        this.orderPreciosMonitor();
      }),

    );

  }

  ngOnInit() {
    this.loadMonitor();
  }

  ngAfterViewInit() {
    // CUSTOM VERTICAL SCROLL CON STICKY HEADER
    this.verticalScroll = window.document.querySelector('.mat-drawer-content');

    // INFINITE SCROLL
    this.scrollSubscriber = Observable.fromEvent(this.verticalScroll, 'scroll')
      .debounceTime(300)
      .map(() => this.verticalScroll.scrollTop)
      .subscribe(x => {
        if (this.view !== this.grillaKey) {return; }
        const max = this.verticalScroll.scrollHeight - this.verticalScroll.clientHeight;
        if (x > max * 0.7) {
          this.pageCtrl.setValue(this.pageCtrl.value + 1);
          this.loadGrilla();
        }
      });
  }

  ngOnDestroy() {
    this.destroySubject.next();
  }

  creadorFilterInitialized() {
    // en el afterViewInit nos suscribimos a los cambios de busqueda que suceden en los componentes
    // primero nos suscribimos al searchvalue del componente,
    // usamos debouncetime para dar tiempo al usuario para escribir y usamos switchmap para obtener el ultimo resultado:
    // cuando realizamos una busqueda, si la busqueda cambia a la mitad de la solicitud devolvera el ultimo resultado en lugar del antiguo
    this.responsableComp.searchSubscription = this.responsableComp.$searchValue.debounceTime(1000).switchMap(res => {
      // aqui realizamos la busqueda
      const searchVal = res.trim();
      if (searchVal.length >= 3) {
        return this.searchService.searchAutocomplete(searchVal, SEARCH_TYPE_COLABORADOR);
      } else {
        // si no hay mas de 3 caracteres, eliminamos la busqueda
        this.responsablesOptions = [];
        return Observable.from([[]]);
      }
    }).subscribe(res => {
      // finalmente nos suscribimos al resultado de la busqueda
      if (res && res.length) {
        this.responsablesOptions = res.map(x => ({Label: x.UserFullName, Id: x.UserId})) ;
      }
    });
  }

  validadorFilterInitialized() {
    this.validadoresComp.searchSubscription = this.validadoresComp.$searchValue.debounceTime(1000).switchMap(res => {
      // aqui realizamos la busqueda
      const searchVal = res.trim();
      if (searchVal.length >= 3) {
        return this.searchService.searchAutocomplete(searchVal, SEARCH_TYPE_COLABORADOR);
      } else {
        // si no hay mas de 3 caracteres, eliminamos la busqueda
        this.validadoresOptions = [];
        return Observable.from([[]]);
      }
    }).subscribe(res => {
      // finalmente nos suscribimos al resultado de la busqueda
      if (res && res.length) {
        this.validadoresOptions = res.map(x => ({Label: x.UserFullName, Id: x.UserId})) ;
      }
    })
  }

  loadMonitor() {
    this.spinnerService.setSoftSpinnerShowFlag(true);
    this.monitorLoading = true;
    this.financieraService.getPreciosMonitor().subscribe(res => {
      if (res) {
        this.preciosMonitorRaw = res;
        this.orderPreciosMonitor();
      }
      this.spinnerService.setSoftSpinnerShowFlag(false);
      this.monitorLoading = false;
    }, err => {
      this.spinnerService.setSoftSpinnerShowFlag(false);
      this.monitorLoading = false;
    });
  }

  loadGrilla() {
    this.spinnerService.setSoftSpinnerShowFlag(true);
    this.grillaLoading = true;
    this.financieraService.getPreciosGrilla(this.grillaFilterForm.getRawValue()).subscribe(res => {
      if (res) {
        this.cotizacionGrilla = [...this.cotizacionGrilla, ...res];
        this.grillaLoaded = true;
        this.grillaLoading = false;
        this.spinnerService.setSoftSpinnerShowFlag(false);
      }
    }, err => {
      this.grillaLoading = true;
      this.spinnerService.setSoftSpinnerShowFlag(false);
    });
  }

  changeViewMode(view) {
    this.view = view;
    if (this.view === this.grillaKey && !this.grillaLoaded) {
      this.loadGrilla();
    }
  }

  getCellValue(col, row) {
    switch (col) {
      case 'Cotización':
        return moment.unix(row.FechaCotizacion).format('DD/MM/YY');
      case 'Publicación':
        return moment.unix(row.FechaPublicacion).format('DD/MM/YY HH.mm') + ' hs.';
      case 'Precio':
        return this.pricePipe.transform(row.Valor, 'fill,2');
      case 'Responsable':
        return row.UsuarioCreador.UserFullName;
      case 'Validador':
        return row.UsuarioValidador.UserFullName;
      case 'Entidad':
        return row.SubentidadFinanciera.EntidadFinanciera ? row.SubentidadFinanciera.EntidadFinanciera.Nombre : '-';
      case 'Subtipo':
        return row.SubentidadFinanciera.Nombre;
    }
  }

  toggleFilters(state = null, e = null) {
    if (e === null || e.srcElement.id === 'monitorFilterClick' || e.srcElement.id === 'grillaFilterClick') {
      this.showFilters = state !== null ? state : !this.showFilters;
    }
  }

  selectedDate(e, entity) {
    const noEvent = {emitEvent: false};
    // estos filtros se cancelan entre si en el back por lo que se cancelan en el front
    const desde = entity === this.FECHA.CREACION_DESDE || entity === this.FECHA.TEMPORAL_DESDE;
    if (entity === this.FECHA.CREACION_DESDE || entity === this.FECHA.CREACION_HASTA) {
      const dates = this.normalizeDate(desde, desde ? e : this.fechaCreacionDesde, desde ? this.fechaCreacionHasta : e);
      this.fechaCreacionDesdeCtrl.setValue(dates.desde, noEvent);
      this.fechaCreacionHastaCtrl.setValue(dates.hasta, noEvent);
      this.marcaTemporalDesdeCtrl.setValue('', noEvent);
      this.marcaTemporalHastaCtrl.setValue('', noEvent);
    } else if (entity === this.FECHA.TEMPORAL_DESDE || entity === this.FECHA.TEMPORAL_HASTA) {
      const dates = this.normalizeDate(desde, desde ? e : this.marcaTemporalDesde, desde ? this.marcaTemporalHasta : e);
      this.marcaTemporalDesdeCtrl.setValue(dates.desde, noEvent);
      this.marcaTemporalHastaCtrl.setValue(dates.hasta, noEvent);
      this.fechaCreacionDesdeCtrl.setValue('', noEvent);
      this.fechaCreacionHastaCtrl.setValue('', noEvent);
    }
  }

  normalizeDate(isDesde, desde, hasta) {
    let retDesde = desde != null ? moment(desde).startOf('day').toDate() : null;
    let retHasta = hasta != null ? moment(hasta).endOf('day').toDate() : null;
    if (isDesde) {
      if (hasta === null) {
        retHasta = moment().endOf('day').toDate();
      } else {
        if (retDesde > hasta) {
          retHasta = moment(retDesde).endOf('day').toDate();
        }
      }
    } else {
      if (desde === null) {
        retDesde = moment(retHasta).startOf('day').toDate();
      } else {
        if (retHasta < desde) {
          retDesde = moment(retHasta).startOf('day').toDate();
        }
      }
    }
    return {desde: retDesde, hasta: retHasta};
  }

  resetGrillaPrecios() {
    this.pageCtrl.setValue(0);
    this.cotizacionGrilla = [];
  }

  eliminarFiltros() {
    this.grillaFilterForm.reset(this.filtersInitialState, {emitEvent: false});
    this.toggleFilters(false);
    this.loadGrilla();
  }

  applyFilters() {
    this.resetGrillaPrecios();
    this.loadGrilla();
  }

  loadSubtiposFilter() {
    const items = [];
    const allowedEnt = this.entidadesFilter.map(x => x.Id);
    this.entidadesOptions.forEach(x => {
      // en caso de que hayamos creado un filtro de entidad, solo agregamos los valores de las subentidades de dichas entidades
      if (allowedEnt.length && allowedEnt.indexOf(x.Id) < 0) {
        return;
      }
      JSON.parse(x.RawValue).Subentidades.forEach(sub => {
        items.push({
          Id: sub.ID,
          Label: `${x.Label} - ${sub.Nombre}`
        });
      });
    });
    this.subtiposOptions = [...items];
    // eliminamos la seleccion de subentidades
    this.subtiposFilterCtrl.setValue([]);
  }

  changeOrInvertFiltering(titulo) {
    if (this.ColumnOrder !== titulo) {
      this.ColumnOrderCtrl.setValue(titulo);
      this.AscendingOrderCtrl.setValue(false);
    } else {
      this.AscendingOrderCtrl.setValue(!this.AscendingOrder);
    }
    this.resetGrillaPrecios();
    this.loadGrilla();
  }

  orderPreciosMonitor() {
    if (this.monitorGroupCtrl.value.Id === this.monitorOrderCtrl.value.Id) {
      this.monitorOrderCtrl.setValue(
        this.monitorGroupCtrl.value.Id === 'ent' ? this.ordeAgrRawOpts.subtipo : this.ordeAgrRawOpts.entidadFinanciera
      );
    }

    // dado que ya no poseemos un sistema HTML de opciones, no podemos usar una manera de prevenir este error por fuera.
    // Simplemente modificamos las opciones de ordenamiento para evitar que se muestren opciones
    // iguales en agrupar y ordenar
    const agrupacionId = this.ordenMonitorForm.get('monitorGroup').value.Id;
    this.ordenarMonitorOptions = [
      agrupacionId === this.ordeAgrRawOpts.entidadFinanciera ? this.ordeAgrRawOpts.subtipo : this.ordeAgrRawOpts.entidadFinanciera,
      this.ordeAgrRawOpts.publicacion,
    ]

    if (this.preciosMonitorRaw.length) {
      let precios = this.preciosMonitorRaw.map(x => {
        return {
          Fecha: moment.unix(x.FechaPublicacion).format('HH:mm') + ' hs.',
          Grupo: this.monitorGroupCtrl.value.Id === 'ent' ? x.SubentidadFinanciera.EntidadFinanciera.Nombre : x.SubentidadFinanciera.Nombre,
          Superior: this.monitorGroupCtrl.value.Id === 'ent' ? x.SubentidadFinanciera.Nombre : x.SubentidadFinanciera.EntidadFinanciera.Nombre,
          Inferior: '', // inferior se usa para mostrar posiciones, no lo necesitamos
          Moneda: '',
          Precio: this.pricePipe.transform(x.Valor, 'fill,2'),
          Varianza: x.Varianza !== null ? x.Varianza : 0,
          PrecioRAW: this.parseFinancieraGenericPrecio(x),
          FechaRaw: x.FechaPublicacion
        } as PrecioMonitor;
      });

      precios = precios.filter(precio => {
        // recorremos el array de filtros usamos for pues podemos retornar mientras iteramos
        for (let i = 0; i < this.filterTipoPrecio.length; i++) {
          // cache del filtro a verificar
          const filter = this.filterTipoPrecio[i];
          // si el filtro esta activo
          if (filter.selected) {
            if (filter.label === 'HOY') {
              return moment.unix(precio.PrecioRAW.FechaCreacion).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY');
            }
            if (filter.label === 'MAÑANA') {
              return moment.unix(precio.PrecioRAW.FechaCreacion).format('DD/MM/YYYY') === moment().add('days', 1).format('DD/MM/YYYY');
            }
            return true;
          }
        }
        return false;
      });

      precios.sort((a, b) => {
        // Paso 1: Ordenar los Grupos
        if (a.Grupo !== b.Grupo) {
          return compare(a.Grupo, b.Grupo, this.monitorGroupDirection)
        }

        // Paso 2: Orden interno
        switch (this.monitorOrderCtrl.value.Id) {
          case 'ent':
          case 'sub':
            // comparamos segun el orden superior y si son iguales, por fecha.
            return a.Superior === b.Superior ? compare(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection)
              : compare(a.Superior, b.Superior, this.monitorOrderDirection);
          case 'publ':
            return compare(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection);
        }
        return 0;
      });

      this.monitorGenericoPrecios = [];
      this.monitorGenericoPrecios = precios.slice();
    } else {
      this.monitorGenericoPrecios = [];
    }
  }

  parseFinancieraGenericPrecio(precio: CotizacionViewModel): PrecioGenericViewModel {
    return {
      FechaCreacion: precio.FechaCotizacion,
      FechaPublicacion: precio.FechaPublicacion,
      Id: precio.Id,
      Moneda: precio.Moneda,
      Precio: precio.Valor,
      Usuario: precio.UsuarioCreador,
      Validador: precio.UsuarioValidador,
      Varianza: precio.Varianza,
      SubentidadFinanciera: precio.SubentidadFinanciera
    }
  }

  changePrecioTypeFilter(index: number) {
    if (!this.filterTipoPrecio[index].selected) {
      this.filterTipoPrecio.forEach(x => x.selected = false);
      this.filterTipoPrecio[index].selected = true;
      this.orderPreciosMonitor();
    }
  }

  public printPrecios() {
    const esHoy = this.filterTipoPrecio.some(x => x.label === 'HOY' && x.selected);
    const fecha = moment().add('days', esHoy ? 0 : 1).toDate();
    this.dialogsService.imprimirPreciosPNG('Dólar', fecha, this.monitorGenericoPrecios);
  }

  get pageCtrl() { return this.grillaFilterForm.get('page'); }
  get monitorGroupCtrl() { return this.ordenMonitorForm.get('monitorGroup'); }
  get monitorGroupDirection() { return this.ordenMonitorForm.get('monitorGroupDirection').value; }
  get monitorGroupDirectionCtrl() { return this.ordenMonitorForm.get('monitorGroupDirection'); }
  get monitorOrderCtrl() { return this.ordenMonitorForm.get('monitorOrder'); }
  get monitorOrderDirection() { return this.ordenMonitorForm.get('monitorOrderDirection').value; }
  get monitorOrderDirectionCtrl() { return this.ordenMonitorForm.get('monitorOrderDirection'); }

  get ColumnOrder() { return this.grillaFilterForm.get('ColumnOrder').value; }
  get ColumnOrderCtrl() { return this.grillaFilterForm.get('ColumnOrder'); }
  get AscendingOrder() { return this.grillaFilterForm.get('AscendingOrder').value; }
  get AscendingOrderCtrl() { return this.grillaFilterForm.get('AscendingOrder'); }
  get entidadesFilterCtrl() { return this.grillaFilterForm.get('entidad'); }
  get entidadesFilter() { return this.grillaFilterForm.get('entidad').value as FormSelectMultipleItem[]; }
  get subtiposFilterCtrl() { return this.grillaFilterForm.get('subentidad'); }

  get fechaCreacionDesdeCtrl() { return this.grillaFilterForm.get('fechaCreacionDesde'); }
  get fechaCreacionHastaCtrl() { return this.grillaFilterForm.get('fechaCreacionHasta'); }
  get marcaTemporalDesdeCtrl() { return this.grillaFilterForm.get('marcaTemporalDesde'); }
  get marcaTemporalHastaCtrl() { return this.grillaFilterForm.get('marcaTemporalHasta'); }

  get fechaCreacionDesde() { return this.grillaFilterForm.get('fechaCreacionDesde').value; }
  get fechaCreacionHasta() { return this.grillaFilterForm.get('fechaCreacionHasta').value; }
  get marcaTemporalDesde() { return this.grillaFilterForm.get('marcaTemporalDesde').value; }
  get marcaTemporalHasta() { return this.grillaFilterForm.get('marcaTemporalHasta').value; }

}

interface DolarFilters {
  ColumnOrder: string,
  AscendingOrder: boolean,
  fechaCreacionDesde: Date,
  fechaCreacionHasta: Date,
  marcaTemporalDesde: Date | null,
  marcaTemporalHasta: Date | null,
  entidad: number[],
  subentidad: number[],
  page: number,
  creador: number[],
  validador: number[],
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/financiera/financiera.component.ts